interface IRoutes {
    [key: string]: string;
}

export const routes: IRoutes = {
    "Home": "/home",
    "RSVP": "/rsvp",
    "DressCode": "/dress-code",
    "GiftRegistry": "/gifts",
    "Alcohol": "/info",
    "FAQ": "/faq",
    "CodeGate": "/code-gate"
};